
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13322',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13322",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.892",
  "client-types": "static-1.501",
  "data-fetching-client": "static-1.10003",
  "foundations-components": "static-1.8567",
  "foundations-components-legacy": "static-1.1592",
  "foundations-theming": "static-1.4830",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.90",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8389",
  "hub-http-shared-msw-handlers": "static-1.10703",
  "hubspot-dlb": "static-2.1905",
  "hubspot-url-utils": "static-1.4366",
  "HubStyleTokens": "static-2.11844",
  "I18n": "static-7.1681",
  "jasmine-runner": "static-1.6802",
  "marketplace-discovery-studio-lib": "static-1.718",
  "marketplace-storefront-base": "static-1.13385",
  "quartz": "static-1.7518",
  "react-dlb": "static-1.90",
  "react-rhumb": "static-1.17076",
  "reactive-variable-buffer-atom": "static-1.3206",
  "reporting-testing-lib": "static-1.10904",
  "reselect": "static-3.13",
  "settings-ui-lib": "static-1.12876",
  "SharedI18nStrings": "static-1.184",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7694",
  "ui-addon-i18n": "static-1.11500",
  "ui-addon-react-router-dom": "static-1.9885",
  "unified-auth": "static-1.1007",
  "unified-auth-core-lib": "static-1.1289",
  "usage-tracker": "static-1.7665",
  "usage-tracker-core": "static-1.7515",
  "customer-data-property-utils": "static-1.8446",
  "hub-http": "static-1.6565",
  "integrations-lib": "static-1.17167",
  "marketplace-ui-common": "static-1.20831",
  "marketplace-ui-install": "static-1.817",
  "property-management-iframe": "static-1.14229",
  "quartz-config": "static-1.1296",
  "quartz-core": "static-1.6737",
  "quartz-routing": "static-1.948",
  "quick-fetch": "static-1.4159",
  "react": "static-7.199",
  "rpc-client-utils": "static-1.5018",
  "ts-schema": "static-1.4327",
  "ui-universal-auth": "static-1.9493",
  "UIComponents": "static-3.8790",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.87",
  "metrics-js": "static-1.9963",
  "react-redux": "static-7.79",
  "redux": "static-4.80",
  "styled-components": "static-2.99",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3795",
  "quartz-webpack": "static-1.3742",
  "bend-plugin-quartz-routing": "static-1.596",
  "ai-components-ui-library": "static-1.9816",
  "codemirror": "static-5.103",
  "foundations-assets": "static-1.5239",
  "pulse": "static-1.983",
  "react-codemirror": "static-1.10996",
  "ui-extensions-preview-lib": "static-1.699",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4836",
  "floating-ui": "static-1.64",
  "foundations-theming-specialty": "static-1.2546",
  "framer-motion": "static-1.80",
  "hs-story-utils": "static-1.9777",
  "react-aria": "static-1.73",
  "react-create-root-preference": "static-1.80",
  "react-select-plus": "static-1.114",
  "react-utils": "static-2.5590",
  "react-virtualized": "static-2.108",
  "StyleGuideUI": "static-3.509",
  "tanstack-table": "static-1.62",
  "trellis-assets": "static-1.2763",
  "ui-fonts": "static-1.1106",
  "ui-images": "static-2.1265",
  "bend-plugin-foundations-theming": "static-1.3313",
  "foundations-theming-base": "static-1.3815",
  "stylex": "static-1.42",
  "HeadJS": "static-2.805",
  "hs-test-utils-bend-plugin": "static-1.3500",
  "msw": "static-1.39",
  "testing-library": "static-1.159",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.92",
  "jasmine": "static-4.4665",
  "ui-addon-video-player": "static-1.9050",
  "ai-rendering-library": "static-1.11189",
  "chirp-fetch": "static-1.2250",
  "connections-embed-lib": "static-1.1581",
  "copilot-toolkit": "static-1.11934",
  "feedback-loader": "static-1.29880",
  "laboratory-lib": "static-3.7505",
  "marketplace-embed": "static-1.23006",
  "marketplace-ui-details": "static-1.10726",
  "marketplace-ui-reviews": "static-1.20786",
  "marketplace-ui-tracking": "static-1.15001",
  "sanitize-text": "static-1.8510",
  "usage-tracker-multi": "static-1.6079",
  "usage-tracker-session-replay": "static-1.5351",
  "wootric-nps": "static-1.7232",
  "quartz-head": "static-1.1183",
  "web-vitals": "static-1.16",
  "apollo-link-hub-http": "static-2.5005",
  "immer": "static-1.102",
  "immerable": "static-1.4498",
  "highcharts": "static-8.112",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2722",
  "reporting-data": "static-1.68971",
  "cssUtils": "static-1.976",
  "flux-actions": "static-1.375",
  "react-colorpicker": "static-2.10567",
  "react-dnd-compat": "static-1.4968",
  "redux-observable": "static-1.76",
  "ReduxMessenger": "static-2.10724",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7655",
  "icons": "static-2.695",
  "marketplace-ui-apps-core": "static-1.19363",
  "storybook-react": "static-1.41",
  "trellis-story-utils": "static-1.4860",
  "foundations-components-test-utils": "static-1.6050",
  "quartz-i18n": "static-1.1193",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.557",
  "ads-unified-auth-lib": "static-1.1544",
  "custom-vendor-connection-lib": "static-1.57",
  "google-sheets-integration-lib": "static-1.1120",
  "microsoft-drive-auth-lib": "static-1.253",
  "surveymonkey-integration-lib": "static-1.594",
  "slack-ui-library": "static-1.10751",
  "fsm": "static-1.4106",
  "customer-data-objects": "static-1.8048",
  "property-translator": "static-1.5740",
  "hs-locale-management": "static-1.328",
  "frontend-preferences-client": "static-1.8271",
  "hs-promise-utils": "static-1.5943",
  "hubspot-apollo-client": "static-1.5228",
  "integrations-error-boundary-lib": "static-1.14582",
  "integrations-tracking-lib": "static-1.5963",
  "native-integrations-shared-strings": "static-1.8125",
  "sanitize": "static-1.4824",
  "superstore": "static-1.5113",
  "ui-shepherd-react": "static-3.10624",
  "ai-settings-ui-library": "static-1.8411",
  "hub-http-janus": "static-1.889",
  "hubspotter-http": "static-1.4895",
  "immutable-less": "static-1.5003",
  "marketplace-ui-client-types": "static-1.18238",
  "nav-meta": "static-1.30559",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18445",
  "ui-product-approvals-common": "static-1.1215",
  "ai-studio-lib": "static-1.12512",
  "hubspot-prosemirror": "static-1.19071",
  "integrations-reconnect-lib": "static-1.554",
  "ui-addon-iframeable": "static-1.9430",
  "ui-addon-integrations-directory-panel": "static-2.8375",
  "ui-product-approvals": "static-1.29320",
  "ui-tool-access": "static-1.10507",
  "inbound-db-properties-service-client": "static-1.4081",
  "property-management-common": "static-1.6517",
  "opentelemetry-fe-types": "static-1.132",
  "dispatcher": "static-1.144",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.585",
  "module-federation": "static-1.34",
  "opentelemetry-fe": "static-1.507",
  "quartz-auth": "static-1.1193",
  "quartz-test": "static-1.1193",
  "quartz-tracking": "static-1.897",
  "trellis-components": "static-1.2782",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.428",
  "HubStyle": "static-2.12151",
  "bender-build-tools": "static-1.3452",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23262",
  "ContentUtils": "static-1.69223",
  "customer-data-objects-ui-components": "static-1.13384",
  "sassPrefix": "static-1.242",
  "diff-match-patch": "static-1.7",
  "bend-plugin-pulse": "static-1.486",
  "batch-promise": "static-1.1897",
  "event-emitter": "static-1.1310",
  "fast-json-patch": "static-1.71",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5793",
  "magpie-types": "static-1.5253",
  "stylex-utils": "static-1.149",
  "trellis-theming": "static-1.1327",
  "avatar-components": "static-1.2837",
  "breeze-engine-core": "static-1.1147",
  "breeze-onboarding-components": "static-1.827",
  "customer-data-filters-ui": "static-1.41058",
  "customer-data-reference-ui-components": "static-1.13527",
  "embedded-academy-lib": "static-1.15679",
  "ExportDialog": "static-6.10732",
  "global-styles-ai-lib": "static-1.240",
  "highlight.js": "static-1.87",
  "marketplace-embed-ba": "static-1.709",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.3",
  "reporting-action-components": "static-1.42154",
  "reporting-snowflake": "static-1.57587",
  "reporting-ui-components": "static-2.66240",
  "reporting-visualizations": "static-1.61045",
  "trial-components-library": "static-1.14189",
  "ui-addon-teams": "static-1.21960",
  "upgrade-components-lib": "static-1.582",
  "navigation-components": "static-1.18922",
  "breeze-engine-lib": "static-1.1869",
  "simple-logging-lib": "static-1.3403",
  "nudge-client-utils": "static-1.3220",
  "fail-safe": "static-1.308",
  "app-governance-lib": "static-1.2479",
  "developer-experience-shared-components": "static-1.10890",
  "purchase-motions-components": "static-1.6465",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10423",
  "usage-tracker-anonymous": "static-1.6082",
  "usage-tracker-public": "static-1.7476",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3718",
  "persist-promise": "static-1.4054",
  "reference-resolvers": "static-1.8533",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4270",
  "hubspot-apollo-cache": "static-1.687",
  "universal-page-editor-lib": "static-1.3362",
  "final-form": "static-1.79",
  "redux-toolkit": "static-1.79",
  "simple-data-table": "static-1.3604",
  "merchandise-lib": "static-1.279",
  "ui-addon-draggable": "static-3.5105",
  "content-assistance-lib": "static-1.8266",
  "content-media-capture": "static-1.5541",
  "customer-data-ui-utilities": "static-1.10184",
  "emoji-mart": "static-3.4",
  "file-manager-components": "static-1.24608",
  "growth-payments-core": "static-1.26280",
  "knowledge-content-types": "static-1.8697",
  "PatternValidationJS": "static-1.3244",
  "payment-link-components": "static-1.24235",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20378",
  "ui-addon-emoji-picker": "static-1.10231",
  "ui-business-units-lib": "static-1.9444",
  "video-components-external": "static-1.12234",
  "video-data-lib": "static-1.35892",
  "navigation-messaging": "static-1.8249",
  "collaboration-sidebar": "static-1.58818",
  "crm-component-utils": "static-1.39938",
  "crm-properties-common-lib": "static-1.6242",
  "customer-data-properties": "static-1.52727",
  "external-options-client-types": "static-1.4374",
  "framework-data-schema-resolvers": "static-1.7247",
  "property-value-citations": "static-1.3341",
  "reference-resolvers-lite": "static-1.8456",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.58",
  "hubspotter-http-shared-msw-handlers": "static-1.10701",
  "base-ui": "static-1.23",
  "react-day-picker": "static-1.11",
  "tanstack-virtual": "static-1.39",
  "cms-field-types": "static-1.5164",
  "content-icons-ui": "static-1.2410",
  "atom": "static-1.5434",
  "idb-keyval": "static-1.52",
  "reactive-lib": "static-1.1071",
  "breeze-artifacts-sdk": "static-1.513",
  "getting-started-shared-tasks": "static-1.19341",
  "onboarding-journeys-lib": "static-1.1029",
  "onboarding-scopes": "static-1.6805",
  "conversations-skeleton-state": "static-1.7596",
  "crm-message-bus": "static-1.43864",
  "customer-data-filters-ui-msw-helpers": "static-1.23493",
  "events-data-lib": "static-1.601",
  "FormUrlGenerator": "static-2.5074",
  "framework-builder-read-service-client": "static-1.4255",
  "hs-resources": "static-1.546",
  "multi-account-reference-resolvers": "static-1.1359",
  "onboarding-tours": "static-1.17207",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14553",
  "segments-client-types": "static-1.11708",
  "academy-common-lib": "static-1.15139",
  "dashboard-lib": "static-1.82984",
  "hubspot-prosemirror-plugins": "static-1.19063",
  "share-with-third-party-component-lib": "static-1.9062",
  "ui-asset-management-lib": "static-1.11455",
  "user-context": "static-1.5469",
  "reporting-plugins": "static-1.10826",
  "reporting-reports": "static-1.68647",
  "hubs-service-types": "static-1.1613",
  "purchase-motions-api": "static-1.6468",
  "salesImages": "static-1.613",
  "signup-constants": "static-1.19707",
  "nest": "static-1.589",
  "breeze-engine-chat-components": "static-1.847",
  "ably": "static-2.2",
  "nudge-custom-function-registry": "static-1.2977",
  "nudge-renderer-utils": "static-1.3296",
  "whisper-core-api": "static-1.7418",
  "bend-plugin-fail-safe": "static-1.259",
  "framework-listing-lib": "static-2.29594",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31512",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4586",
  "signup-ui-url-generator": "static-2.8412",
  "onboarding-tours-client": "static-1.5422",
  "one-click-checkout": "static-1.517",
  "platform-infra-nav-components": "static-1.7927",
  "subscription-experience-data-types": "static-1.15293",
  "crm-record-cards-service-types": "static-1.3800",
  "location-customization-utils-lib": "static-1.10199",
  "redux-thunk": "static-2.81",
  "react-flip-move": "static-1.79",
  "ui-coaching-tips": "static-1.29398",
  "content-media-composition-data-lib": "static-1.13345",
  "fix-webm-duration": "static-1.31",
  "notification-sounds": "static-1.4777",
  "react-immutable-render-mixin": "static-1.9",
  "seat-types-lib": "static-1.806",
  "ui-addon-opt": "static-4.8714",
  "commerce-tours-lib": "static-1.6693",
  "growth-onboarding-reliability": "static-1.5434",
  "sales-checkout-service-client": "static-1.3882",
  "data-token-picker": "static-1.16956",
  "FileManagerLib": "static-1.40248",
  "content-media-compositions": "static-2.17352",
  "media-bridge-lib": "static-1.19474",
  "chatspot-widget-iframe": "static-1.23253",
  "collaboration-sidebar-common": "static-1.3615",
  "marketing-platform-lib": "static-1.7226",
  "card-properties-lib": "static-1.45104",
  "commerce-subscription-lib": "static-1.37878",
  "crm-actions": "static-1.6702",
  "crm-cards-sdk": "static-1.44699",
  "customer-data-properties-shared-msw-handlers": "static-1.10030",
  "customer-data-tracking": "static-1.7229",
  "calling-global-api": "static-1.65776",
  "calling-internal-common": "static-1.31674",
  "calling-lifecycle-internal": "static-1.67158",
  "calling-lifecycle-messages": "static-1.59452",
  "commerce-products-lib": "static-1.10642",
  "conditional-properties-service-client": "static-1.4050",
  "crm-index-visualization-core": "static-1.4598",
  "crm-links": "static-1.6658",
  "crm-pipelines-api-client-types": "static-1.4381",
  "formula-editor": "static-1.14839",
  "google-libphonenumber": "static-1.46",
  "inbounddb-objects-service-types": "static-1.4458",
  "meetings-icalendar-utils-lib": "static-1.988",
  "multi-currency-client-types": "static-1.3941",
  "object-builder-ui-client": "static-1.49790",
  "pipeline-validation-client-types": "static-1.4216",
  "smart-data-capture-core": "static-1.221",
  "smart-property-lib": "static-1.8403",
  "tiered-pricing": "static-1.2038",
  "topics-actions-lib": "static-1.523",
  "ui-addon-form-validation": "static-1.11332",
  "zustand": "static-1.86",
  "fdsr-migration-layer": "static-1.366",
  "framework-data-schema-quick-fetch": "static-1.7152",
  "restore-request-side-panel-lib": "static-1.1767",
  "growth-data-modal": "static-1.5963",
  "growth-onboarding-confetti": "static-1.3418",
  "growth-onboarding-next-action-utils": "static-1.2779",
  "onboarding-tours-utils": "static-1.1274",
  "ui-shepherd-tracker": "static-1.8005",
  "crm-index-associations-lib": "static-1.6798",
  "academy-service-client": "static-1.4044",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40107",
  "SafeStorage": "static-1.4753",
  "video-embed": "static-1.36726",
  "redux-actions": "static-3.71",
  "EmailSignatureEditor": "static-1.25072",
  "viral-links-lib": "static-1.7428",
  "nested-table": "static-1.588",
  "timezone-utils": "static-2.5590",
  "getting-started-shared-tasks-store": "static-1.18459",
  "campaign-roi-lib": "static-1.10479",
  "campaigns-utils-lib": "static-1.3580",
  "ui-addon-calendars": "static-2.5698",
  "customer-data-views-management": "static-1.26118",
  "framework-data-table": "static-2.12637",
  "nudge-custom-ui-functions": "static-1.1570",
  "switchboard-lib": "static-1.574",
  "access-check-ui-lib": "static-1.1680",
  "app-users-service-client": "static-1.5973",
  "app-users-service-types": "static-1.5381",
  "mini-checkout-client": "static-1.27612",
  "onboarding-utils": "static-1.5723",
  "permissions-shared-i18n-strings-fe": "static-1.2130",
  "ui-coaching-tips-shared-config": "static-1.29383",
  "checkout-sdk": "static-3.24455",
  "payment-method-components": "static-1.7199",
  "touchless-buying-components": "static-1.6323",
  "upgrade-catalog-service-types": "static-1.3796",
  "edison-service-client-types": "static-1.749",
  "growth-onboarding-feedback-components": "static-1.6938",
  "audio-components": "static-1.6413",
  "FileManagerImages": "static-1.37759",
  "video-components": "static-1.14236",
  "js-cookie": "static-1.18",
  "crm_data": "static-4.92944",
  "customer-data-sidebar": "static-2.46822",
  "enrichment-lib": "static-1.588",
  "ui-addon-draggable-compat": "static-2.4615",
  "universal-record-utils-lib": "static-1.2097",
  "commerce-billing-lib": "static-1.20307",
  "commerce-shared-components-lib": "static-1.19340",
  "commerce-tools-ui-lib": "static-1.11131",
  "crm-fe-perf": "static-1.23251",
  "calling-error-reporting": "static-1.31681",
  "shared-worker-versioning": "static-1.11394",
  "calling-usage-tracker": "static-1.6889",
  "voice-sms-access-library": "static-1.2165",
  "commerce-permissions": "static-1.1130",
  "products-iframe-lib": "static-1.8674",
  "products-ui-components-shared-msw-handlers": "static-1.11085",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10786",
  "sales-views-client-types": "static-1.4609",
  "bark-lib": "static-1.16870",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.720",
  "policy-lib": "static-1.7159",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10849",
  "onboarding-data-sync-lib": "static-1.2601",
  "growth-onboarding-next-action-components": "static-1.2807",
  "user-context-client": "static-1.4862",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.62",
  "urlinator": "static-1.4877",
  "outpost": "static-1.4499",
  "draft-convert": "static-2.81",
  "draft-extend": "static-3.84",
  "draft-js": "static-5.86",
  "draft-plugins": "static-2.22219",
  "sales-email-signature-service-client": "static-1.4200",
  "ts-utils-lib": "static-1.501",
  "copilot-messaging": "static-1.2184",
  "crm-export-dialog": "static-1.6637",
  "crm-index-ui-shimmer": "static-1.2770",
  "crm-view-components": "static-1.1290",
  "react-beautiful-dnd": "static-1.71",
  "customer-data-associations": "static-1.7682",
  "tasks-actions-lib": "static-1.230",
  "InboxConnectUtils": "static-4.15645",
  "emoji-regex": "static-1.7",
  "settings-content-modals": "static-1.46935",
  "hub-http-rxjs": "static-1.856",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4344",
  "company-details-components": "static-1.6559",
  "react-performance-metrics-lib": "static-1.906",
  "pricing-pages-ui-components": "static-1.16019",
  "quote-checkout-service-types": "static-1.3807",
  "social-insights-client-types": "static-1.22728",
  "crm_universal": "static-1.22555",
  "customer-data-email": "static-1.18583",
  "card-payment-highlight-lib": "static-1.38091",
  "commerce-contract-lib": "static-1.13492",
  "invoices-highlight-card-lib": "static-1.55877",
  "orders-highlight-card-lib": "static-1.22283",
  "products-highlight-card-lib": "static-1.18925",
  "quotes-highlight-card-lib": "static-1.72866",
  "crm-source-interpretation-lib": "static-1.5684",
  "data-agent-utils": "static-1.650",
  "crm-object-search-query-utilities": "static-1.10274",
  "utility-belt": "static-1.2885",
  "payments-enrollment-embed-lib": "static-1.23933",
  "stripe-embedded-components": "static-1.8064",
  "customer-data-rte": "static-1.33719",
  "cv-backend-services": "static-1.1597",
  "growth-onboarding-empty-states": "static-1.6355",
  "payments-post-enroll-local-storage-lib": "static-1.5456",
  "qrcode-generator": "static-1.77",
  "quotes-client-types": "static-1.38956",
  "calling-orchestration-schema": "static-1.36942",
  "react-reducer-toolkit": "static-1.16452",
  "meetings-connect-utils-lib": "static-1.7964",
  "hub-http-contrib": "static-1.3387",
  "ui-addon-sales-email": "static-1.5561",
  "access-control-lib": "static-1.10784",
  "EmailComponents": "static-1.55640",
  "EmailData": "static-1.54318",
  "redux-less": "static-2.9823",
  "company-details-service-types": "static-1.4295",
  "segments-query-core": "static-1.1778",
  "pricing-pages-api": "static-1.15884",
  "sequences-lib": "static-1.8599",
  "ui-gdpr-components": "static-1.10644",
  "products-ui-components": "static-1.41160",
  "accounting-integrations-ui-components": "static-1.7606",
  "invoices-ui-lib": "static-1.55893",
  "commerce-products-api": "static-1.2749",
  "invoices-iframe-lib": "static-1.57951",
  "quotes-modal-lib": "static-1.103544",
  "quotes-ui-lib": "static-1.81587",
  "stripe-connect-js": "static-1.78",
  "draft-content-plugins": "static-1.28978",
  "ContentComponents": "static-2.72179",
  "ContentData": "static-1.69298",
  "marketing-email-service-types": "static-1.2127",
  "messaging-editing-lib": "static-1.47249",
  "messaging-usage-based-billing-components-lib": "static-1.2111",
  "automation-ui-source-apps": "static-1.19774",
  "automation-ui-types": "static-1.20692",
  "messaging-types-lib": "static-1.46986",
  "onboarding-settings-client": "static-1.4861",
  "sequences-client-types-lib": "static-1.8456",
  "commerce-tax-lib": "static-1.892",
  "price-books-api": "static-1.1818",
  "price-books-components": "static-1.1876",
  "property-description-translator": "static-1.4183",
  "ramp-editor": "static-1.972",
  "commerce-analytics-service-client": "static-1.3870",
  "totals-ui-components": "static-1.24375",
  "SalesContentIndexUI": "static-3.9675",
  "advanced-menus-core": "static-1.15643",
  "advanced-menus-lib": "static-1.12506",
  "automation-ui-ubb": "static-1.6608",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7690",
  "data-token-views": "static-1.16937",
  "forms-utils-lib": "static-1.13158",
  "payments-embed-points-lib": "static-1.13665",
  "react-tinymce": "static-1.56067",
  "simple-menus-core": "static-1.15642",
  "simple-menus-lib": "static-1.17159",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55193",
  "tinymce-data": "static-1.41278",
  "tinymce-plugins": "static-1.58307",
  "tinymce-themes": "static-1.57163",
  "ui-brand-identity-lib": "static-1.16658",
  "ui-memberships-settings-lib": "static-1.34932",
  "videoconference-integration-components": "static-1.7360",
  "automation-applications-service-types": "static-1.3665",
  "automation-platform-service-types": "static-1.2676",
  "ContentEditorUI": "static-2.78008",
  "content-whatsapp-service-types": "static-1.584",
  "short-messages-app-service-client": "static-1.4273",
  "web-interactives-components": "static-1.14313",
  "web-interactives-data": "static-1.14314",
  "messaging-shared-utils-lib": "static-1.1560",
  "messaging-user-info-utils-lib": "static-1.1730",
  "email-portal-health-service-types": "static-1.1335",
  "line-items-api": "static-1.1158",
  "commerce-totals-service-types": "static-1.4066",
  "FireAlarmUi": "static-1.4756",
  "sales-templates-service-types-lib": "static-1.4418",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.22628",
  "automation-ui-usage-tracking": "static-1.22091",
  "data-studio-ubb": "static-1.3597",
  "interframe": "static-3.5102",
  "layout-dnd-components": "static-1.13040",
  "layout-dnd-utils": "static-1.12015",
  "NamespacedHubStyle": "static-2.9295",
  "campaigns-lib": "static-1.27736",
  "content-management-data-lib": "static-1.6039",
  "copilot-plugins": "static-1.11906",
  "cta-picker": "static-1.37160",
  "customer-agent-discovery-components-lib": "static-1.4047",
  "editor-components": "static-1.13717",
  "editor-iframe-lib": "static-1.8856",
  "error-messaging-js": "static-1.5546",
  "FormsCommonComponents": "static-1.86658",
  "layout-data-lib": "static-1.10340",
  "pictos": "static-7.191",
  "react-transition-group": "static-2.74",
  "redux-request-state": "static-1.10995",
  "SharedLegalStrings": "static-1.2089",
  "smart-content-core": "static-1.43260",
  "smart-content-lib": "static-1.43913",
  "social-composer-lib": "static-1.60378",
  "structured-content-lib": "static-1.26002",
  "theme-previewer-lib": "static-1.53994",
  "tinymce-copilot": "static-1.17261",
  "xray-recommendation-lib": "static-1.8321",
  "automation-ui-routing": "static-1.22049",
  "sql-reporting-client-types": "static-1.5930",
  "attribution-lib": "static-1.42863",
  "reporting-enablement": "static-1.23921",
  "forms-ai-lib": "static-1.4827",
  "codemirror-dlb": "static-1.59567",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6795",
  "report-customization-components": "static-1.13995",
  "data-quality-ui-library": "static-1.13964",
  "reporting-filters": "static-1.1081",
  "reporting-insights-lib": "static-1.2673",
  "merge-modal-lib": "static-1.12720"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13322",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.892",
  "client-types": "/client-types/static-1.501",
  "data-fetching-client": "/data-fetching-client/static-1.10003",
  "foundations-components": "/foundations-components/static-1.8567",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1592",
  "foundations-theming": "/foundations-theming/static-1.4830",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.90",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8389",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10703",
  "hubspot-dlb": "/hubspot-dlb/static-2.1905",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4366",
  "HubStyleTokens": "/HubStyleTokens/static-2.11844",
  "I18n": "/I18n/static-7.1681",
  "jasmine-runner": "/jasmine-runner/static-1.6802",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.718",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13385",
  "quartz": "/quartz/static-1.7518",
  "react-dlb": "/react-dlb/static-1.90",
  "react-rhumb": "/react-rhumb/static-1.17076",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3206",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.10904",
  "reselect": "/reselect/static-3.13",
  "settings-ui-lib": "/settings-ui-lib/static-1.12876",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.184",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7694",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11500",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9885",
  "unified-auth": "/unified-auth/static-1.1007",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1289",
  "usage-tracker": "/usage-tracker/static-1.7665",
  "usage-tracker-core": "/usage-tracker-core/static-1.7515",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8446",
  "hub-http": "/hub-http/static-1.6565",
  "integrations-lib": "/integrations-lib/static-1.17167",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20831",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.817",
  "property-management-iframe": "/property-management-iframe/static-1.14229",
  "quartz-config": "/quartz-config/static-1.1296",
  "quartz-core": "/quartz-core/static-1.6737",
  "quartz-routing": "/quartz-routing/static-1.948",
  "quick-fetch": "/quick-fetch/static-1.4159",
  "react": "/react/static-7.199",
  "rpc-client-utils": "/rpc-client-utils/static-1.5018",
  "ts-schema": "/ts-schema/static-1.4327",
  "ui-universal-auth": "/ui-universal-auth/static-1.9493",
  "UIComponents": "/UIComponents/static-3.8790",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.87",
  "metrics-js": "/metrics-js/static-1.9963",
  "react-redux": "/react-redux/static-7.79",
  "redux": "/redux/static-4.80",
  "styled-components": "/styled-components/static-2.99",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3795",
  "quartz-webpack": "/quartz-webpack/static-1.3742",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.596",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9816",
  "codemirror": "/codemirror/static-5.103",
  "foundations-assets": "/foundations-assets/static-1.5239",
  "pulse": "/pulse/static-1.983",
  "react-codemirror": "/react-codemirror/static-1.10996",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.699",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4836",
  "floating-ui": "/floating-ui/static-1.64",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2546",
  "framer-motion": "/framer-motion/static-1.80",
  "hs-story-utils": "/hs-story-utils/static-1.9777",
  "react-aria": "/react-aria/static-1.73",
  "react-create-root-preference": "/react-create-root-preference/static-1.80",
  "react-select-plus": "/react-select-plus/static-1.114",
  "react-utils": "/react-utils/static-2.5590",
  "react-virtualized": "/react-virtualized/static-2.108",
  "StyleGuideUI": "/StyleGuideUI/static-3.509",
  "tanstack-table": "/tanstack-table/static-1.62",
  "trellis-assets": "/trellis-assets/static-1.2763",
  "ui-fonts": "/ui-fonts/static-1.1106",
  "ui-images": "/ui-images/static-2.1265",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3313",
  "foundations-theming-base": "/foundations-theming-base/static-1.3815",
  "stylex": "/stylex/static-1.42",
  "HeadJS": "/HeadJS/static-2.805",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3500",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.159",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.92",
  "jasmine": "/jasmine/static-4.4665",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9050",
  "ai-rendering-library": "/ai-rendering-library/static-1.11189",
  "chirp-fetch": "/chirp-fetch/static-1.2250",
  "connections-embed-lib": "/connections-embed-lib/static-1.1581",
  "copilot-toolkit": "/copilot-toolkit/static-1.11934",
  "feedback-loader": "/feedback-loader/static-1.29880",
  "laboratory-lib": "/laboratory-lib/static-3.7505",
  "marketplace-embed": "/marketplace-embed/static-1.23006",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10726",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20786",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15001",
  "sanitize-text": "/sanitize-text/static-1.8510",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6079",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5351",
  "wootric-nps": "/wootric-nps/static-1.7232",
  "quartz-head": "/quartz-head/static-1.1183",
  "web-vitals": "/web-vitals/static-1.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5005",
  "immer": "/immer/static-1.102",
  "immerable": "/immerable/static-1.4498",
  "highcharts": "/highcharts/static-8.112",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2722",
  "reporting-data": "/reporting-data/static-1.68971",
  "cssUtils": "/cssUtils/static-1.976",
  "flux-actions": "/flux-actions/static-1.375",
  "react-colorpicker": "/react-colorpicker/static-2.10567",
  "react-dnd-compat": "/react-dnd-compat/static-1.4968",
  "redux-observable": "/redux-observable/static-1.76",
  "ReduxMessenger": "/ReduxMessenger/static-2.10724",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7655",
  "icons": "/icons/static-2.695",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19363",
  "storybook-react": "/storybook-react/static-1.41",
  "trellis-story-utils": "/trellis-story-utils/static-1.4860",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6050",
  "quartz-i18n": "/quartz-i18n/static-1.1193",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.557",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1544",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.57",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1120",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.253",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.594",
  "slack-ui-library": "/slack-ui-library/static-1.10751",
  "fsm": "/fsm/static-1.4106",
  "customer-data-objects": "/customer-data-objects/static-1.8048",
  "property-translator": "/property-translator/static-1.5740",
  "hs-locale-management": "/hs-locale-management/static-1.328",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8271",
  "hs-promise-utils": "/hs-promise-utils/static-1.5943",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5228",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14582",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5963",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8125",
  "sanitize": "/sanitize/static-1.4824",
  "superstore": "/superstore/static-1.5113",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10624",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8411",
  "hub-http-janus": "/hub-http-janus/static-1.889",
  "hubspotter-http": "/hubspotter-http/static-1.4895",
  "immutable-less": "/immutable-less/static-1.5003",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18238",
  "nav-meta": "/nav-meta/static-1.30559",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18445",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1215",
  "ai-studio-lib": "/ai-studio-lib/static-1.12512",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19071",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.554",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9430",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8375",
  "ui-product-approvals": "/ui-product-approvals/static-1.29320",
  "ui-tool-access": "/ui-tool-access/static-1.10507",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4081",
  "property-management-common": "/property-management-common/static-1.6517",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.132",
  "dispatcher": "/dispatcher/static-1.144",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.585",
  "module-federation": "/module-federation/static-1.34",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.507",
  "quartz-auth": "/quartz-auth/static-1.1193",
  "quartz-test": "/quartz-test/static-1.1193",
  "quartz-tracking": "/quartz-tracking/static-1.897",
  "trellis-components": "/trellis-components/static-1.2782",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.428",
  "HubStyle": "/HubStyle/static-2.12151",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23262",
  "ContentUtils": "/ContentUtils/static-1.69223",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13384",
  "sassPrefix": "/sassPrefix/static-1.242",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.486",
  "batch-promise": "/batch-promise/static-1.1897",
  "event-emitter": "/event-emitter/static-1.1310",
  "fast-json-patch": "/fast-json-patch/static-1.71",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5793",
  "magpie-types": "/magpie-types/static-1.5253",
  "stylex-utils": "/stylex-utils/static-1.149",
  "trellis-theming": "/trellis-theming/static-1.1327",
  "avatar-components": "/avatar-components/static-1.2837",
  "breeze-engine-core": "/breeze-engine-core/static-1.1147",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.827",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41058",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13527",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15679",
  "ExportDialog": "/ExportDialog/static-6.10732",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.240",
  "highlight.js": "/highlight.js/static-1.87",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.709",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.3",
  "reporting-action-components": "/reporting-action-components/static-1.42154",
  "reporting-snowflake": "/reporting-snowflake/static-1.57587",
  "reporting-ui-components": "/reporting-ui-components/static-2.66240",
  "reporting-visualizations": "/reporting-visualizations/static-1.61045",
  "trial-components-library": "/trial-components-library/static-1.14189",
  "ui-addon-teams": "/ui-addon-teams/static-1.21960",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.582",
  "navigation-components": "/navigation-components/static-1.18922",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1869",
  "simple-logging-lib": "/simple-logging-lib/static-1.3403",
  "nudge-client-utils": "/nudge-client-utils/static-1.3220",
  "fail-safe": "/fail-safe/static-1.308",
  "app-governance-lib": "/app-governance-lib/static-1.2479",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10890",
  "purchase-motions-components": "/purchase-motions-components/static-1.6465",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10423",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6082",
  "usage-tracker-public": "/usage-tracker-public/static-1.7476",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "persist-promise": "/persist-promise/static-1.4054",
  "reference-resolvers": "/reference-resolvers/static-1.8533",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4270",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.687",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3362",
  "final-form": "/final-form/static-1.79",
  "redux-toolkit": "/redux-toolkit/static-1.79",
  "simple-data-table": "/simple-data-table/static-1.3604",
  "merchandise-lib": "/merchandise-lib/static-1.279",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5105",
  "content-assistance-lib": "/content-assistance-lib/static-1.8266",
  "content-media-capture": "/content-media-capture/static-1.5541",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10184",
  "emoji-mart": "/emoji-mart/static-3.4",
  "file-manager-components": "/file-manager-components/static-1.24608",
  "growth-payments-core": "/growth-payments-core/static-1.26280",
  "knowledge-content-types": "/knowledge-content-types/static-1.8697",
  "PatternValidationJS": "/PatternValidationJS/static-1.3244",
  "payment-link-components": "/payment-link-components/static-1.24235",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20378",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10231",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9444",
  "video-components-external": "/video-components-external/static-1.12234",
  "video-data-lib": "/video-data-lib/static-1.35892",
  "navigation-messaging": "/navigation-messaging/static-1.8249",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.58818",
  "crm-component-utils": "/crm-component-utils/static-1.39938",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6242",
  "customer-data-properties": "/customer-data-properties/static-1.52727",
  "external-options-client-types": "/external-options-client-types/static-1.4374",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7247",
  "property-value-citations": "/property-value-citations/static-1.3341",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8456",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.58",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10701",
  "base-ui": "/base-ui/static-1.23",
  "react-day-picker": "/react-day-picker/static-1.11",
  "tanstack-virtual": "/tanstack-virtual/static-1.39",
  "cms-field-types": "/cms-field-types/static-1.5164",
  "content-icons-ui": "/content-icons-ui/static-1.2410",
  "atom": "/atom/static-1.5434",
  "idb-keyval": "/idb-keyval/static-1.52",
  "reactive-lib": "/reactive-lib/static-1.1071",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.513",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19341",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1029",
  "onboarding-scopes": "/onboarding-scopes/static-1.6805",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7596",
  "crm-message-bus": "/crm-message-bus/static-1.43864",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23493",
  "events-data-lib": "/events-data-lib/static-1.601",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5074",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4255",
  "hs-resources": "/hs-resources/static-1.546",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1359",
  "onboarding-tours": "/onboarding-tours/static-1.17207",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14553",
  "segments-client-types": "/segments-client-types/static-1.11708",
  "academy-common-lib": "/academy-common-lib/static-1.15139",
  "dashboard-lib": "/dashboard-lib/static-1.82984",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19063",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9062",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11455",
  "user-context": "/user-context/static-1.5469",
  "reporting-plugins": "/reporting-plugins/static-1.10826",
  "reporting-reports": "/reporting-reports/static-1.68647",
  "hubs-service-types": "/hubs-service-types/static-1.1613",
  "purchase-motions-api": "/purchase-motions-api/static-1.6468",
  "salesImages": "/salesImages/static-1.613",
  "signup-constants": "/signup-constants/static-1.19707",
  "nest": "/nest/static-1.589",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.847",
  "ably": "/ably/static-2.2",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2977",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3296",
  "whisper-core-api": "/whisper-core-api/static-1.7418",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.259",
  "framework-listing-lib": "/framework-listing-lib/static-2.29594",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31512",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4586",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8412",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5422",
  "one-click-checkout": "/one-click-checkout/static-1.517",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7927",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15293",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3800",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10199",
  "redux-thunk": "/redux-thunk/static-2.81",
  "react-flip-move": "/react-flip-move/static-1.79",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29398",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13345",
  "fix-webm-duration": "/fix-webm-duration/static-1.31",
  "notification-sounds": "/notification-sounds/static-1.4777",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "seat-types-lib": "/seat-types-lib/static-1.806",
  "ui-addon-opt": "/ui-addon-opt/static-4.8714",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6693",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5434",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3882",
  "data-token-picker": "/data-token-picker/static-1.16956",
  "FileManagerLib": "/FileManagerLib/static-1.40248",
  "content-media-compositions": "/content-media-compositions/static-2.17352",
  "media-bridge-lib": "/media-bridge-lib/static-1.19474",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23253",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3615",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7226",
  "card-properties-lib": "/card-properties-lib/static-1.45104",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37878",
  "crm-actions": "/crm-actions/static-1.6702",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44699",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10030",
  "customer-data-tracking": "/customer-data-tracking/static-1.7229",
  "calling-global-api": "/calling-global-api/static-1.65776",
  "calling-internal-common": "/calling-internal-common/static-1.31674",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67158",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59452",
  "commerce-products-lib": "/commerce-products-lib/static-1.10642",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4050",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4598",
  "crm-links": "/crm-links/static-1.6658",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4381",
  "formula-editor": "/formula-editor/static-1.14839",
  "google-libphonenumber": "/google-libphonenumber/static-1.46",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4458",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.988",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3941",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49790",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4216",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.221",
  "smart-property-lib": "/smart-property-lib/static-1.8403",
  "tiered-pricing": "/tiered-pricing/static-1.2038",
  "topics-actions-lib": "/topics-actions-lib/static-1.523",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11332",
  "zustand": "/zustand/static-1.86",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.366",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7152",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1767",
  "growth-data-modal": "/growth-data-modal/static-1.5963",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3418",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2779",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1274",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8005",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6798",
  "academy-service-client": "/academy-service-client/static-1.4044",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40107",
  "SafeStorage": "/SafeStorage/static-1.4753",
  "video-embed": "/video-embed/static-1.36726",
  "redux-actions": "/redux-actions/static-3.71",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25072",
  "viral-links-lib": "/viral-links-lib/static-1.7428",
  "nested-table": "/nested-table/static-1.588",
  "timezone-utils": "/timezone-utils/static-2.5590",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18459",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10479",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3580",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5698",
  "customer-data-views-management": "/customer-data-views-management/static-1.26118",
  "framework-data-table": "/framework-data-table/static-2.12637",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1570",
  "switchboard-lib": "/switchboard-lib/static-1.574",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1680",
  "app-users-service-client": "/app-users-service-client/static-1.5973",
  "app-users-service-types": "/app-users-service-types/static-1.5381",
  "mini-checkout-client": "/mini-checkout-client/static-1.27612",
  "onboarding-utils": "/onboarding-utils/static-1.5723",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2130",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29383",
  "checkout-sdk": "/checkout-sdk/static-3.24455",
  "payment-method-components": "/payment-method-components/static-1.7199",
  "touchless-buying-components": "/touchless-buying-components/static-1.6323",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3796",
  "edison-service-client-types": "/edison-service-client-types/static-1.749",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6938",
  "audio-components": "/audio-components/static-1.6413",
  "FileManagerImages": "/FileManagerImages/static-1.37759",
  "video-components": "/video-components/static-1.14236",
  "js-cookie": "/js-cookie/static-1.18",
  "crm_data": "/crm_data/static-4.92944",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46822",
  "enrichment-lib": "/enrichment-lib/static-1.588",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4615",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2097",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20307",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19340",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11131",
  "crm-fe-perf": "/crm-fe-perf/static-1.23251",
  "calling-error-reporting": "/calling-error-reporting/static-1.31681",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11394",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6889",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2165",
  "commerce-permissions": "/commerce-permissions/static-1.1130",
  "products-iframe-lib": "/products-iframe-lib/static-1.8674",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11085",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10786",
  "sales-views-client-types": "/sales-views-client-types/static-1.4609",
  "bark-lib": "/bark-lib/static-1.16870",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.720",
  "policy-lib": "/policy-lib/static-1.7159",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10849",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2601",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2807",
  "user-context-client": "/user-context-client/static-1.4862",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.62",
  "urlinator": "/urlinator/static-1.4877",
  "outpost": "/outpost/static-1.4499",
  "draft-convert": "/draft-convert/static-2.81",
  "draft-extend": "/draft-extend/static-3.84",
  "draft-js": "/draft-js/static-5.86",
  "draft-plugins": "/draft-plugins/static-2.22219",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4200",
  "ts-utils-lib": "/ts-utils-lib/static-1.501",
  "copilot-messaging": "/copilot-messaging/static-1.2184",
  "crm-export-dialog": "/crm-export-dialog/static-1.6637",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2770",
  "crm-view-components": "/crm-view-components/static-1.1290",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.71",
  "customer-data-associations": "/customer-data-associations/static-1.7682",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.230",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15645",
  "emoji-regex": "/emoji-regex/static-1.7",
  "settings-content-modals": "/settings-content-modals/static-1.46935",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.856",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4344",
  "company-details-components": "/company-details-components/static-1.6559",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.906",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16019",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3807",
  "social-insights-client-types": "/social-insights-client-types/static-1.22728",
  "crm_universal": "/crm_universal/static-1.22555",
  "customer-data-email": "/customer-data-email/static-1.18583",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.38091",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.13492",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55877",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22283",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18925",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72866",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5684",
  "data-agent-utils": "/data-agent-utils/static-1.650",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10274",
  "utility-belt": "/utility-belt/static-1.2885",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23933",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8064",
  "customer-data-rte": "/customer-data-rte/static-1.33719",
  "cv-backend-services": "/cv-backend-services/static-1.1597",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6355",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5456",
  "qrcode-generator": "/qrcode-generator/static-1.77",
  "quotes-client-types": "/quotes-client-types/static-1.38956",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36942",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16452",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7964",
  "hub-http-contrib": "/hub-http-contrib/static-1.3387",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5561",
  "access-control-lib": "/access-control-lib/static-1.10784",
  "EmailComponents": "/EmailComponents/static-1.55640",
  "EmailData": "/EmailData/static-1.54318",
  "redux-less": "/redux-less/static-2.9823",
  "company-details-service-types": "/company-details-service-types/static-1.4295",
  "segments-query-core": "/segments-query-core/static-1.1778",
  "pricing-pages-api": "/pricing-pages-api/static-1.15884",
  "sequences-lib": "/sequences-lib/static-1.8599",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10644",
  "products-ui-components": "/products-ui-components/static-1.41160",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7606",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.55893",
  "commerce-products-api": "/commerce-products-api/static-1.2749",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57951",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.103544",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.81587",
  "stripe-connect-js": "/stripe-connect-js/static-1.78",
  "draft-content-plugins": "/draft-content-plugins/static-1.28978",
  "ContentComponents": "/ContentComponents/static-2.72179",
  "ContentData": "/ContentData/static-1.69298",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.2127",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.47249",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.2111",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.19774",
  "automation-ui-types": "/automation-ui-types/static-1.20692",
  "messaging-types-lib": "/messaging-types-lib/static-1.46986",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4861",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8456",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.892",
  "price-books-api": "/price-books-api/static-1.1818",
  "price-books-components": "/price-books-components/static-1.1876",
  "property-description-translator": "/property-description-translator/static-1.4183",
  "ramp-editor": "/ramp-editor/static-1.972",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3870",
  "totals-ui-components": "/totals-ui-components/static-1.24375",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9675",
  "advanced-menus-core": "/advanced-menus-core/static-1.15643",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12506",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.6608",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7690",
  "data-token-views": "/data-token-views/static-1.16937",
  "forms-utils-lib": "/forms-utils-lib/static-1.13158",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13665",
  "react-tinymce": "/react-tinymce/static-1.56067",
  "simple-menus-core": "/simple-menus-core/static-1.15642",
  "simple-menus-lib": "/simple-menus-lib/static-1.17159",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55193",
  "tinymce-data": "/tinymce-data/static-1.41278",
  "tinymce-plugins": "/tinymce-plugins/static-1.58307",
  "tinymce-themes": "/tinymce-themes/static-1.57163",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16658",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34932",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.7360",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3665",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2676",
  "ContentEditorUI": "/ContentEditorUI/static-2.78008",
  "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.584",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4273",
  "web-interactives-components": "/web-interactives-components/static-1.14313",
  "web-interactives-data": "/web-interactives-data/static-1.14314",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1560",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1730",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1335",
  "line-items-api": "/line-items-api/static-1.1158",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.4066",
  "FireAlarmUi": "/FireAlarmUi/static-1.4756",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4418",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.22628",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.22091",
  "data-studio-ubb": "/data-studio-ubb/static-1.3597",
  "interframe": "/interframe/static-3.5102",
  "layout-dnd-components": "/layout-dnd-components/static-1.13040",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12015",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9295",
  "campaigns-lib": "/campaigns-lib/static-1.27736",
  "content-management-data-lib": "/content-management-data-lib/static-1.6039",
  "copilot-plugins": "/copilot-plugins/static-1.11906",
  "cta-picker": "/cta-picker/static-1.37160",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.4047",
  "editor-components": "/editor-components/static-1.13717",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8856",
  "error-messaging-js": "/error-messaging-js/static-1.5546",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.86658",
  "layout-data-lib": "/layout-data-lib/static-1.10340",
  "pictos": "/pictos/static-7.191",
  "react-transition-group": "/react-transition-group/static-2.74",
  "redux-request-state": "/redux-request-state/static-1.10995",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.2089",
  "smart-content-core": "/smart-content-core/static-1.43260",
  "smart-content-lib": "/smart-content-lib/static-1.43913",
  "social-composer-lib": "/social-composer-lib/static-1.60378",
  "structured-content-lib": "/structured-content-lib/static-1.26002",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53994",
  "tinymce-copilot": "/tinymce-copilot/static-1.17261",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.8321",
  "automation-ui-routing": "/automation-ui-routing/static-1.22049",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5930",
  "attribution-lib": "/attribution-lib/static-1.42863",
  "reporting-enablement": "/reporting-enablement/static-1.23921",
  "forms-ai-lib": "/forms-ai-lib/static-1.4827",
  "codemirror-dlb": "/codemirror-dlb/static-1.59567",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6795",
  "report-customization-components": "/report-customization-components/static-1.13995",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13964",
  "reporting-filters": "/reporting-filters/static-1.1081",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.2673",
  "merge-modal-lib": "/merge-modal-lib/static-1.12720"
}
};
